<template>
	<div style="background-color: #fff;min-height: 100vh;padding: 1vh 1vw;">
		<div  style="text-align: left;">
			<el-form :inline="true">
				<el-form-item label="创建时间">
					<el-date-picker v-model="queryTime" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getBillList()">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div style="margin-top: 2vh;">
			<el-table :data="billList" style="width: 100%"
				:header-cell-style="{background:'#eceff4',color:'#7f7f7f','font-weight': 500,'font-family': 'sans-serif','color': '#000'}">
				<el-table-column prop="billId" label="账单编号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="creationTime" label="账单生成日期" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="billName" label="账单名称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="customerName" label="结算对象" header-align="center"
					align="center"></el-table-column>
				<!-- <el-table-column prop="status" label="状态" header-align="center" align="center"></el-table-column> -->
				<el-table-column prop="totalAmount" label="总金额" header-align="center" align="center"></el-table-column>
				<!-- <el-table-column prop="unpaidAmount" label="待收金额" header-align="center" align="center"></el-table-column> -->
				<el-table-column label="操作" header-align="center" align="center">
					<template #default="scope">
						<div>
							<div><el-button type="text" @click="open(scope.row)">查看详情</el-button></div>
							<div style=""><el-button type="text"
									@click="exportTable(scope.row)">导出表格</el-button></div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				billList: [],
				queryTime: [new Date(new Date().setHours(0, 0, 0, 0) - 7 * 24 * 60 * 60 * 1000), new Date(new Date()
					.setHours(23, 59, 59, 0))],
			}
		},
		methods: {
			getBillList() {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "getBillList",
						content: {
							startTime: this.queryTime[0],
							endTime: this.queryTime[1]
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.billList = res.data.billList;
						}
					})
					.finally(() => {
						loading.close();
					})
			},
			open(data) {
				this.$router.push({
					path: "/finance/bill/detail",
					query: {
						billId: data.billId
					}
				});
			},
			exportTable(data) {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "exportBillTable",
						content: {
							"billId": data.billId
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.$alert('已生成下载任务，您可在下载中心查看', '导出结果', {
								confirmButtonText: '点击查看',
								callback: confirm => {
									console.log(confirm)
									// this.$router.push('/download')
								}
							});
						}
					})
					.finally(() => {
						loading.close();
					})
			
			}
		},
		mounted() {
			this.getBillList()
		}
	}
</script>

<style scoped>

</style>